/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

export const useBookingSellerReservationPersonSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z.object({
        name: z.string().min(1, t('First name is required')),
        last_name: z.string().min(1, t('Last name is required')),
        email: z.string().email(t('Invalid email')).optional().or(z.literal('')),
        birthdate: z.string().min(1, t('Birthdate is required')),
        packages_cart_item_id: z.number().min(1, t('Please select a ticket')),
    }), [t])
}

export type BookingSellerReservationPersonInputs = z.infer<ReturnType<typeof useBookingSellerReservationPersonSchema>>
